<div class="bg-gray-600 h-full lg:flex flex-col justify-center items-center text-white bg">
  <a href="https://app.onafriq.com/" target="_blank">
    <img src="assets/images/logo/full-white.svg" alt="beyonic logo" width="155" height="55" class="w-[270px] mb-5" />
  </a>
  <span class="text-white text-center font-normal text-xl z-10 mb-40 mx-44" data-test-id="blurb"
    >Effortlessly collect payments from your customers, make payouts to your vendors, and manage your cash flow.</span
  >
</div>
